<template>  
  <div class="breadcrumbs" v-if="collection">
    <a class="body-sm color-dark-grey" v-if="collection" :href="`/collections/${collection.handle}`">{{ collection.title }}</a>
    <span class="body-sm color-dark-grey divider" v-if="collection">/</span>
    <span class="body-sm color-black active">{{ staticProductTitle }}</span>
  </div>
</template>

<script>
export default {
  props: {
    collection: Object,
    product: Object
  },
  computed: {
    staticProductTitle() {
      const t = this.product.title;
      return t.substr(0, t.lastIndexOf('-'));
    }
  }
}
</script>

<style lang="scss" scoped>
  .breadcrumbs {
    display: none;

    .active {
      font-weight: 500;
    }

    a {
      text-decoration: none !important;
    }

    @include tablet-up {
      text-align: left;
      padding-bottom: 8px;
      display: block;
    }
    .divider {
      padding: 0 3px;
      font-size: rem(13);
    }
  }
</style>
